import React, { useRef } from "react";
import { message } from "antd";
import { ISCMShopFormFields } from "../shopService";
import { useShopModel } from "../shopModel";
import { useMdmModel } from "../../../../model/mdmModel";
import { IYhFormRef, IYhForm, FormItemTypeEnum, ISelectOption } from "../../../../components2/YhFormBox/Types";
import { getFormValidatorErrText, loadDictParam } from "../../../../utils/utils";
import { AppDrawer } from "../../../../components2/YhDrawer";
import { YhForm } from "../../../../components2/YhFormBox";
import { ITreeSelectData } from "../../../../components2/YhPageHeader/Types";


export function DetailDrawer() {
    const { entity, mdmBranch, mdmOrgan, dict } = useMdmModel();
    const { shopDrawer: { visible, mode }, setIShopDrawer, insertShop, editShop, getSelectedRowData } = useShopModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setIShopDrawer();
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then((val: ISCMShopFormFields) => {
            let data = {
                ...val,
                status: val.status ? 0 : 1,
                details: val.details?.map(item => ({
                    shopCode: "",
                    bentityCode: item,
                    bentityName: entity.find(origin => origin.value === item)?.label ?? ""
                }))
            }
            mode === "edit" ? editShop(data) : insertShop(data);
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //机构选中
    const onTreeSelectChange = (value: string, node: ITreeSelectData) => {
        node && formRef.current?.setFieldsValue({ orgName: node.title });
    }

    //门店类型
    const categoryChang = (value: string, option: ISelectOption) => {
        // debugger;
        option && formRef.current?.setFieldsValue({ categoryName: option.label });
    }
    //币种
    const currencyChang = (value: string, option: ISelectOption) => {
        // debugger;
        option && formRef.current?.setFieldsValue({ currencyName: option.label });
    }
    //门店区域
    const shopAreaChang = (value: string, option: ISelectOption) => {
        // debugger;
        option && formRef.current?.setFieldsValue({ regionName: option.label });
    }
    //门店性质
    const shopNatureChang = (value: string, option: ISelectOption) => {
        // debugger;
        option && formRef.current?.setFieldsValue({ natureName: option.label });
    }

    const formConfig: IYhForm<ISCMShopFormFields> = {
        formRef,
        labelCol: { span: 6 },
        formValues: mode === "edit" ? getSelectedRowData() : { status: true },
        items: [
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "分支编码",
                fieldName: "branch",
                options: mdmBranch,
                rules: [{ required: true, message: "请选择分支编码" }]
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "门店编码",
                fieldName: "code",
                placeholder: "自动生成",
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "门店名称",
                fieldName: "name",
                span: 24,
                rules: [{ required: true, message: "请输入门店名称" }]
            }, {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "从属机构",
                fieldName: "orgCode",
                onTreeSelectChange,
                treeData: mdmOrgan,
                span: 24,
                rules: [{ required: true, message: "请选择从属机构" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "门店类型",
                onSelectChange: categoryChang,
                fieldName: "categoryCode",
                options: loadDictParam('shop-type', dict),
                rules: [{ required: true, message: "请输入门店类型" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "关联实体",
                fieldName: "details",
                mode: "multiple",
                options: entity,
                rules: [{ required: true, message: "请输入关联实体" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "负责人",
                fieldName: "contact",
                span: 24,
                rules: [{ required: true, message: "请输入负责人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 24,
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "公司地址",
                fieldName: "address",
                span: 24,
                rules: [{ required: true, message: "请输入公司地址" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "币种",
                onSelectChange: currencyChang,
                fieldName: "currency",
                options: loadDictParam('currency', dict),
                rules: [{ required: true, message: "请选择币种" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "门店区域",
                onSelectChange: shopAreaChang,
                fieldName: "region",
                options: loadDictParam('shop-area', dict),
                rules: [{ required: true, message: "请选择门店区域" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "门店性质",
                onSelectChange: shopNatureChang,
                fieldName: "nature",
                options: loadDictParam('shop-nature', dict),
                rules: [{ required: true, message: "请选择门店性质" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "企业状态",
                fieldName: "status",
                span: 24,
                valuePropName: "checked",
                checkedChildren: "启用",
                unCheckedChildren: "禁用"
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构名称",
                fieldName: "orgName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "门店类型名称",
                fieldName: "categoryName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "币种名称",
                fieldName: "currencyName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "性质名称",
                fieldName: "natureName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "区域名称",
                fieldName: "regionName",
                hidden: true
            },
        ]
    };
    return (
        <AppDrawer
            {...{
                title: `门店${mode === "edit" ? "编辑" : "新增"}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </AppDrawer>
    )
}
